import { Component, OnInit, OnChanges, Input, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { DetailRequest } from '../shared/model/detail-request.model';



@Component({
  selector: 'app-detail-request-porficience',
  templateUrl: './detail-request-porficience.component.html',
  styleUrls: ['./detail-request-porficience.component.scss']
})
export class DetailRequestPorficienceComponent implements  OnInit, OnChanges {

  displayedColumns: string[] ;
  dataSource: MatTableDataSource<DetailRequest>;
  selection = new SelectionModel<DetailRequest>(true, []);
  @Input() detailRequest: DetailRequest [];
  @Input() showChecked = true;


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor() {
    this.dataSource = new MatTableDataSource(this.detailRequest);
    if (this.dataSource.paginator) {
     this.dataSource.paginator.firstPage();
    }
   }

  ngOnInit() {
    if (this.showChecked) {
      this.displayedColumns = ['seleccion', 'codigo', 'prueba', 'fecha', 'puntaje', 'archivo'];
    } else {
      this.displayedColumns = ['codigo', 'prueba', 'fecha', 'puntaje', 'archivo'];
    }
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnChanges() {
    this.setData();
  }
   setData() {
     this.dataSource = new MatTableDataSource(this.detailRequest);
     this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort;
     if (this.dataSource.paginator) {
       this.dataSource.paginator.firstPage();
     }
   }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
 masterToggle() {
  this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  setEvalutors(evaluator) {
    this.selection.selected.map(
        (detail) => {
          const index = this.dataSource.filteredData.indexOf(detail);
          this.detailRequest[index].evaluador = evaluator;
          this.setData();
        }
      );
  }

  showPdf(row: DetailRequest) {
    window.open(window.location.origin + window.location.pathname + '#/archivos?cedula=' + row.cedula + '&file=' + row.archivoadjunto);
  }

}

